// extracted by mini-css-extract-plugin
export default {"badgeWrapper":"Rn-z","badgeLink":"Sn-z","category":"Tn-z"};